<div *ngIf="isDialog" class="form-header-container flex-centered-container-vr">
  <h3>UPDATE PASSWORD</h3>
  <span class="spacer"></span>
  <button mat-icon-button tabindex="-1" (click)="closeDialog()">
    <mat-icon> close</mat-icon>
  </button>
</div>

<div class="update-form text-left flex-centered-container-hr-column"
  [ngClass]="{'first-positive padding-hr': !isDialog}">
  <form [formGroup]="changePasswordForm" (submit)="changePassword()" [ngClass]="{'text-center': showPreloginLayout}">
    <h2 class="font-28 margin-top-32 color-text font-inter-semibold" [ngClass]="{'text-center': showPreloginLayout}"
      *ngIf="!affiliate">
      Change Password
    </h2>
    <div class="columns" [ngClass]="{'width-40': !showPreloginLayout && !affiliate}">
      <div [ngClass]="{'padding-hr': isDialog, 'display-flex justify-space-between': affiliate}">
        <div class="current-password-field display-flex input-field margin-8-bottom" *ngIf="!resetToken"
          [ngClass]="{'display-flex-column': !isDialog, 'change-password-field': isDialog,'full-width':!BUILD_DEALER}">
          <mat-form-field class="ut-pro-mat-form-field" color="accent" appearance="outline">
            <mat-label>Current Password</mat-label>
            <input matInput formControlName="oldPassword" [type]="hide[0] ? 'password':'text'">
            <mat-icon matSuffix [svgIcon]="hide[0] ? 'eye_off' : 'eye'" tabindex="0"
              (keydown.enter)="hide[0] = !hide[0]" (click)="hide[0] = !hide[0]"></mat-icon>
            <mat-error class="font-x-small"
              *ngIf="changePasswordForm.get('oldPassword').touched && changePasswordForm.get('oldPassword').hasError('required')">
              Current Password is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="display-flex input-field margin-8-bottom"
          [ngClass]="{'display-flex-column': !isDialog, 'change-password-field': isDialog , 'full-width':!BUILD_DEALER || !userinfo}">
          <mat-form-field class="ut-pro-mat-form-field" color="accent" appearance="outline">
            <mat-label>New Password</mat-label>
            <input matInput formControlName="newPassword" [errorStateMatcher]="matcher"
              [type]="hide[1] ? 'password':'text'">
            <mat-icon matSuffix [svgIcon]="hide[1] ? 'eye_off' : 'eye'" tabindex="0"
              (keydown.enter)="hide[1] = !hide[1]" (click)="hide[1] = !hide[1]"></mat-icon>

            <mat-error class="font-x-small" *ngIf="changePasswordForm.get('newPassword').hasError('required')">
              New Password is required
            </mat-error>
            <mat-error class="font-x-small" *ngIf="changePasswordForm.get('newPassword').value &&
              changePasswordForm.hasError('sameNewOld')">
              Current Password and New Password are same!
            </mat-error>
            <mat-error class="font-x-small"
              *ngIf="!changePasswordForm.hasError('sameNewOld') && changePasswordForm.get('newPassword').hasError('pattern')">
              {{authService.passwordPolicyCache.description}}
            </mat-error>

          </mat-form-field>
        </div>
        <div class="display-flex input-field margin-8-bottom"
          [ngClass]="{'display-flex-column': !isDialog, 'change-password-field': isDialog , 'full-width':!BUILD_DEALER || !userinfo}">
          <mat-form-field class="ut-pro-mat-form-field" color="accent" appearance="outline">
            <mat-label>Confirm Password</mat-label>
            <input matInput formControlName="confirmNewPassword" [errorStateMatcher]="matcher"
              [type]="hide[1] ? 'password':'text'">
            <mat-icon matSuffix [svgIcon]="hide[1] ? 'eye_off' : 'eye'" tabindex="0"
              (keydown.enter)="hide[1] = !hide[1]" (click)="hide[1] = !hide[1]"></mat-icon>

            <mat-error class="font-x-small" *ngIf="changePasswordForm.get('confirmNewPassword').hasError('required')">
              Confirm Password is required
            </mat-error>

            <mat-error class="font-x-small" *ngIf="changePasswordForm.get('confirmNewPassword').touched &&
                          changePasswordForm.get('confirmNewPassword').value &&
                          changePasswordForm.hasError('notSame')">
              Password and Confirm Password do not match.
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="affiliate">
          <button [disabled]="!changePasswordForm.valid" [ngClass]="{'cursor-not-allowed': !changePasswordForm.valid}"
            mat-flat-button color="accent" type="submit" class="submit submit-button ut-pro-button gradient">
            <span class="font-inter-semibold">Change Password</span>
          </button>
        </div>
      </div>
    </div>
    <div class="action-btns margin-32-bot" [ngClass]="{'action-btns-auth': !isDialog, 'action-btns': isDialog}"
      *ngIf="!affiliate">
      <button [disabled]="!changePasswordForm.valid" [ngClass]="{'cursor-not-allowed': !changePasswordForm.valid}"
        mat-flat-button color="accent" type="submit" class="submit submit-button ut-pro-button gradient">
        <span class="font-inter-semibold">Save Password</span>
      </button>
    </div>
  </form>

  <div class="text-accent font-small" [ngClass]="{'display-none': showPreloginLayout}" *ngIf="!affiliate">
    <span>Note: On successfully changing password, all other logged in sessions (on web browser or mobile app) will be
      logged out immediately.</span>
  </div>

  <ngx-turnstile *ngIf="RECAPTCHA_REQUIRED" class="margin-auto" [siteKey]="CAPTCHA_SITEKEY" (resolved)="setCaptchaToken($event)" theme="light"
            [tabIndex]="0"></ngx-turnstile>    
</div>